import { Newspaper } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { LiveNewsFeed } from "@/components/LiveNewsFeed";
import { ConnectGate } from "@/components/ConnectGate";
import { useLang } from "@/context/LanguageContext";

export default function News() {
  const { t } = useLang();
  return (
    <div>
      <PageHeader title={t("page.newsTitle")} subtitle={t("page.newsSub")} icon={Newspaper} />
      <ConnectGate>
        <div className="rounded-lg border border-[#222733] bg-[#11141A] p-4 sm:p-5">
          <LiveNewsFeed />
        </div>
      </ConnectGate>
    </div>
  );
}
